import PropTypes from 'prop-types';
import { Icon } from '@bwoty-web/ui-kit';
import { TRAVEL_AIRPLANE_UP_RIGHT } from '@bwoty-web/ui-kit/icons';

import { getCloudinaryTemplateLogoUrl } from '../../../utils/imageUtils';

import './FlightDetailsHead.scss';

const FlightDetailsHead = ({
  carrierAdditionalText = '',
  flight,
  hideFlightTime = false,
  isHomeBound = false,
  labels,
  withCarrierInfo = false,
}) => {
  let nofStopsText = labels.noLayover;
  if (parseInt(flight.totalNumberOfStops, 10) === 1) {
    nofStopsText = `${flight.totalNumberOfStops} ${labels.stopSingular}`;
  } else if (parseInt(flight.totalNumberOfStops, 10) > 1) {
    nofStopsText = `${flight.totalNumberOfStops} ${labels.stopPlural}`;
  }

  const boundTitle = isHomeBound ? labels.homebound : labels.outbound;

  const carrierImageUrl = getCloudinaryTemplateLogoUrl(flight?.carrierCloudinaryImage, 48);

  return (
    <div className="iw-flight-details-head__heading-spacing">
      <h2 className="iw-flight-details-head__title">
        {boundTitle} {flight.departureDate.toLowerCase()}
      </h2>
      {!hideFlightTime && (
        <div className="iw-flight-details-head__subtitle">
          {`${flight.flightTime && `${flight.flightTime}, `}${nofStopsText}`}
        </div>
      )}
      {withCarrierInfo && (
        <div className="iw-flight-details-head__carrier-container">
          {carrierImageUrl ? (
            <img
              src={carrierImageUrl}
              alt={flight.carrierName}
              className="iw-flight-details-head__carrier-logo"
            />
          ) : (
            <Icon path={TRAVEL_AIRPLANE_UP_RIGHT} />
          )}
          <div className="iw-flight-details-head__carrier-additional-text">
            {carrierAdditionalText && <p>{carrierAdditionalText}</p>}
            <p>{flight.carrierName}</p>
          </div>
        </div>
      )}
    </div>
  );
};

FlightDetailsHead.propTypes = {
  labels: PropTypes.shape({
    technicalLayover: PropTypes.string,
    layover: PropTypes.string,
    operatingCarrier: PropTypes.string,
    stopSingular: PropTypes.string,
    stopPlural: PropTypes.string,
    noLayover: PropTypes.string,
    homebound: PropTypes.string,
    outbound: PropTypes.string,
  }).isRequired,
  flight: PropTypes.shape({
    isStopOver: PropTypes.bool,
    departureTime: PropTypes.string,
    departureDate: PropTypes.string,
    carrierName: PropTypes.string,
    bookingEngineKey: PropTypes.string,
    legs: PropTypes.arrayOf(PropTypes.shape({})),
    hasMultipleCarriers: PropTypes.bool,
    departureDateDayName: PropTypes.string,
    arrivalTime: PropTypes.string,
    arrivalDate: PropTypes.string,
    destinationAirportName: PropTypes.string,
    arrivalDaysAfterDeparture: PropTypes.number,
    departureDateMonthName: PropTypes.string,
    departureLocation: PropTypes.string,
    carrierCloudinaryImage: PropTypes.shape({
      cloudinaryUriTemplate: PropTypes.string,
      size: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
      }),
    }),
    operatedByAnotherCarrier: PropTypes.bool,
    daysOnStopOver: PropTypes.number,
    totalNumberOfStops: PropTypes.string,
    departureDateTime: PropTypes.string,
    luggageTexts: PropTypes.arrayOf(PropTypes.string),
    luggageIncluded: PropTypes.bool,
    departureLocationCode: PropTypes.string,
    cabinClassTexts: PropTypes.arrayOf(PropTypes.string),
    departureDateDay: PropTypes.string,
    destinationCode: PropTypes.string,
    flightTime: PropTypes.string,
  }).isRequired,
  hideFlightTime: PropTypes.bool,
  isHomeBound: PropTypes.bool,
  withCarrierInfo: PropTypes.bool,
  carrierAdditionalText: PropTypes.string,
};

export default FlightDetailsHead;
